export default __webpack_public_path__ + "media/images/icons/icon-arrow-right-small-15c9a051283370a09fe25d35b29e2402.svg";